import './index.less';

import Ocr from './Ocr';
import Asr from './Asr';

type RecognizerSelectorSubComponents = {
  Ocr: typeof Ocr;
  Asr: typeof Asr;
};

const RecognizerSelector: RecognizerSelectorSubComponents = () => null;

RecognizerSelector.Ocr = Ocr;
RecognizerSelector.Asr = Asr;

export default RecognizerSelector;
